import { NavBar as NavbarComponent } from './NavBar';

export const NavBar = NavbarComponent;
